import { render, staticRenderFns } from "./eventListComp.vue?vue&type=template&id=2f4ba0a2&scoped=true"
import script from "./eventListComp.vue?vue&type=script&lang=js"
export * from "./eventListComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4ba0a2",
  null
  
)

export default component.exports